import { window } from "@gr-common/body/namespaces";
export * from "../lib/nexus/index.js";
import * as defines from "@gr-common/body/nexus";
const defineEvent = defines.defineEvent;
const createEventTopic = defines.defineEvent;
const defineFunction = defines.defineFunction;
const defineNamespace = defines.defineNamespace;
const forServer = () => createProxy(createStore(name)[1], configAsync);
const otto = import.meta.env.SSR ? forServer() : window.otto ?? {};
export {
  createEventTopic,
  defineEvent,
  defineFunction,
  defineNamespace,
  otto
};
